<template>
  <div class="formdata owner">
    <div class="header-container">
    <h3 id="wish_heatpump_question">Haben Sie zusätzlich Interesse an einer Wärmepumpe als effizientes Heizsystem?</h3>
</div>
    <CustomRadioGroup
        :options="wishHeatpumpAnswers"
        v-model="selectedAnswer"
        aria-labelledby="wish_heatpump_question"
        @optionSelected="submit"
    >
      <template #option="{ option }">
        <label :for="'wish_heatpump_' + option.value">
          <img :src="option.image" alt="" aria-hidden="true" />
          <p>{{ option.name }}</p>
        </label>
      </template>
    </CustomRadioGroup>

    <button
        class="button button_yellow right"
        v-if="selectedAnswer"
        @click="submit"
    >
      Weiter
    </button>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useWorkflowStore } from '@/stores/workflow';
import { wishHeatpumpAnswers, wishHeatpumpApi } from '@/data/wishHeatpumpData.js';
import CustomRadioGroup from '@/components/CustomRadioGroup.vue';

const workflowStore = useWorkflowStore();

const getAnswerEventData = (selectedValue) => {
  const fullAnswer = wishHeatpumpAnswers.find(bt => bt.value === selectedValue);

  if (fullAnswer) {
    return {
      value: selectedValue,
      apiDefinition: wishHeatpumpApi,
      apiValue: fullAnswer.api,
      available: fullAnswer.available,
    };
  }
  return null;
};

const selectedAnswer = computed({
  get() {
    return workflowStore.workflowContext.formData.building?.wish_heatpump || null;
  },
  set(newValue) {
    const eventData = getAnswerEventData(newValue);
    workflowStore.sendWorkflowEvent({
      type: 'UPDATE_SELECTED_WISH_HEATPUMP_ANSWER',
      data: eventData,
    });
  },
});

const submit = () => {
  if (selectedAnswer.value) {
    const eventData = getAnswerEventData(selectedAnswer.value);
    workflowStore.sendWorkflowEvent({
      type: 'NEXT',
      data: eventData,
    });
  }
};


</script>

